import type { ReassignmentDetail } from '@cartwheel/api/v1'

interface ReassignmentTypeDisplayProps {
  reassignment: ReassignmentDetail
}

export function ReassignmentTypeDisplay({ reassignment }: ReassignmentTypeDisplayProps) {
  if (reassignment.reassignment_type === 'single_client') {
    const clientName = reassignment.journey_info.client_name ?? 'Unknown'
    const clientProfileUrl = reassignment.journey_info.client_profile_url

    if (clientProfileUrl) {
      return (
        <>
          Single client -{' '}
          <a
            href={clientProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-forest hover:underline inline-flex items-center gap-1"
          >
            {clientName}
            <i className="fa-sharp fa-solid fa-arrow-up-right-from-square text-xs" />
          </a>
        </>
      )
    }
    return <>Single client - {clientName}</>
  }

  const count = reassignment.journey_info.count ?? 0
  return <>Entire caseload - {count} clients</>
}
